import * as React from 'react'

import { Input } from 'src/shared/components/ui/inputs/input'
import { Label } from 'src/shared/components/ui/label'
import { cn } from 'src/shared/utils/cn'

export type FloatingInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  labelClassName?: string
}

const FloatingInput = React.forwardRef<HTMLInputElement, FloatingInputProps>(({ className, ...props }, ref) => {
  return <Input placeholder=" " className={cn('peer', className)} ref={ref} {...props} />
})
FloatingInput.displayName = 'FloatingInput'

const FloatingLabel = React.forwardRef<React.ElementRef<typeof Label>, React.ComponentPropsWithoutRef<typeof Label>>(
  ({ className, ...props }, ref) => {
    return (
      <Label
        className={cn(
          'absolute start-2 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform cursor-text bg-background px-2 text-sm font-medium text-muted duration-300 peer-focus:text-primary peer-focus:dark:text-primary',
          'peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-placeholder-shown:text-base',
          'peer-focus:top-1 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2',
          'dark:bg-background rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4',
          '[.input-with-icon_&]:start-8',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
FloatingLabel.displayName = 'FloatingLabel'

type FloatingLabelInputProps = FloatingInputProps & { label?: string }

const FloatingLabelInput = React.forwardRef<
  React.ElementRef<typeof FloatingInput>,
  React.PropsWithoutRef<FloatingLabelInputProps>
>(({ id, label, labelClassName, ...props }, ref) => {
  return (
    <div className="relative">
      <FloatingInput ref={ref} id={id} {...props} />
      <FloatingLabel htmlFor={id} className={labelClassName}>
        {label}
      </FloatingLabel>
    </div>
  )
})
FloatingLabelInput.displayName = 'FloatingLabelInput'

export { FloatingInput, FloatingLabel, FloatingLabelInput }
